import axios from "./axios";

export const getOnboarding = () =>
  axios.get("/api/onboarding").then(res => res.data);

export const createLearner = (body) =>
  axios.post("/api/sign_up/learner", body).then(({ data }) => data);

export const createFacilitator = (body) =>
  axios.post("/api/sign_up/facilitator", body).then(({ data }) => data);

// api/onboarding.ts
export const updateProfile = (payload) =>
  axios.patch("/api/onboarding", payload)
    .then(res => res.data);

export const updateOrgSetup = (payload) =>
  axios.patch("/api/onboarding/orgSetup", payload)
    .then(res => res.data);

export const updateGuardianPermission = (payload) =>
  axios.patch("/api/onboarding/guardian_permission", payload)
    .then(res => res.data);
